module.exports = __webpack_public_path__ + "ed435b606326ed49d60a51e9a6d0097c.svg";